import React, { Fragment } from 'react';
import {
  string,
  func,
  bool,
} from 'prop-types';
import Input from './input';
import StatesDropDown from './states';

const ContactInfo = ({
  address1,
  address1Error,
  address2,
  city,
  cityError,
  email,
  emailError,
  firstName,
  firstNameError,
  handleChange,
  handleOnBlur,
  handleOnKeyPress,
  lastName,
  lastNameError,
  ldap,
  ldapError,
  phoneNumber,
  phoneNumberError,
  showLdap,
  state,
  stateError,
  submitContactInfo,
  zipCode,
  sfiPhoneNumber,
}) => {
  const disableSubmitContactInfo = () => {
    const hasError = (firstNameError || lastNameError || emailError || phoneNumberError
                  || address1Error || cityError || stateError || ldapError);
    return hasError;
  };

  return (
    <Fragment>
      <div className="flex-ns absolute-ns h-100 w-100">
        <div className="w-50-ns w-100 pa4-ns pa3" style={{ overflow: 'auto', paddingTop: '0px' }}>
          <h1 className="mb3 tc tl-ns lh-title f2-ns f3 near-black" >Success!</h1>

          <p className="f5">
            <strong>This service is available in your area.</strong>
            &nbsp;Share your name and contact information and we&#39;ll schedule
            your in-home consultation within 2 business days.
          </p>
          <form onSubmit={submitContactInfo}>
            <div className="flex flex-wrap">
              <div className="w-100 w-50-ns pr2-ns mb2">
                <Input id="firstName" value={firstName} label="First Name" name="first name" errorMessage={firstNameError} handleChange={handleChange} handleOnBlur={handleOnBlur} />
              </div>
              <div className="w-100 w-50-ns mb2">
                <Input id="lastName" value={lastName} label="Last Name" name="last name" errorMessage={lastNameError} handleChange={handleChange} handleOnBlur={handleOnBlur} />
              </div>
              <div className="w-100 mb2">
                <Input id="address1" value={address1} label="Street Address (no P.O. Boxes accepted)" name="address" errorMessage={address1Error} handleChange={handleChange} handleOnBlur={handleOnBlur} />
              </div>
              <div className="w-100 mb2">
                <Input id="address2" value={address2} label="Apt, Suite, Blg (optional)" handleChange={handleChange} />
              </div>
              <div className="w-100 mb2">
                <Input id="city" value={city} label="City" name="address" errorMessage={cityError} handleChange={handleChange} handleOnBlur={handleOnBlur} />
              </div>
              <div className="w-100 w-50-ns pr2-ns mb2">
                <StatesDropDown id="state" value={state} label="State" name="state" errorMessage={stateError} handleChange={handleChange} handleOnBlur={handleOnBlur} />
              </div>
              <div className="w-100 w-50-ns mb2 disabled">
                <Input id="zipCode" value={zipCode} label="Zip Code" disabled />
              </div>
              <div className="w-100 mb2">
                <Input id="email" value={email} label="Email Address" errorMessage={emailError} handleChange={handleChange} handleOnBlur={handleOnBlur} />
              </div>
              <div className="w-100 mb2">
                <Input
                  errorMessage={phoneNumberError}
                  handleChange={handleChange}
                  handleOnBlur={handleOnBlur}
                  handleOnKeyPress={handleOnKeyPress}
                  id="phoneNumber"
                  label="Phone Number"
                  maxLength={10}
                  type="tel"
                  value={phoneNumber}
                />
              </div>
              {
                showLdap &&
                <div className="w-100 mb2">
                  <Input id="ldap" value={ldap} label="THD Ldap" maxLength={8} errorMessage={ldapError} handleChange={handleChange} handleOnBlur={handleOnBlur} />
                </div>
              }
            </div>
            <input className="gcc-btn gcc-btn-secondary w-100" type="submit" value="Submit" disabled={disableSubmitContactInfo()} />
          </form>
          <h4 className="mt4">Our professional installers are:</h4>
          <p className="f6">
            Services in your area are provided in partnership through
            &nbsp;<strong>The Home Depot&#39;s</strong> network of professional installers.
          </p>
          <p className="tc mt3 mb0 f5" style={{ textAlign: 'center' }}>or call <a href={`tel:${sfiPhoneNumber}`} className="fw7 black">{sfiPhoneNumber}</a> to get started.</p>
        </div>
      </div>
    </Fragment>);
};

ContactInfo.defaultProps = {
  address1: '',
  address1Error: '',
  address2: '',
  city: '',
  cityError: '',
  email: '',
  emailError: '',
  firstName: '',
  firstNameError: '',
  handleOnKeyPress: () => { },
  lastName: '',
  lastNameError: '',
  ldap: '',
  ldapError: '',
  phoneNumber: null,
  phoneNumberError: '',
  showLdap: false,
  state: '',
  stateError: '',
  zipCode: '',
};

ContactInfo.propTypes = {
  address1: string,
  address2: string,
  state: string,
  city: string,
  zipCode: string,
  firstName: string,
  lastName: string,
  email: string,
  phoneNumber: string,
  ldap: string,
  phoneNumberError: string,
  firstNameError: string,
  lastNameError: string,
  emailError: string,
  address1Error: string,
  cityError: string,
  stateError: string,
  ldapError: string,
  showLdap: bool,
  submitContactInfo: func.isRequired,
  handleChange: func.isRequired,
  handleOnBlur: func.isRequired,
  handleOnKeyPress: func,
  sfiPhoneNumber: string.isRequired,
};

export default ContactInfo;
